<template>
    <div>
        <van-cell-group>
            <van-field
                    v-model="formData.phone"
                    label="手机号"
                    placeholder="请输入手机号"
            />
            <van-field
                    v-model="formData.code"
                    center
                    clearable
                    label="短信验证码"
                    placeholder="请输入短信验证码"
            >
                <van-button slot="button" size="small" @click="getCode" :disabled="clockSecond>0" type="primary">{{clockSecond>0? clockSecond+'s获取验证码':'获取验证码'}}</van-button>
            </van-field>
            <van-field
                    v-model="formData.name"
                    label="用户名"
                    placeholder="请输入用户名"
            />
            <van-field
                    v-model="formData.password"
                    label="密码"
                    placeholder="请输入密码"
            />
        </van-cell-group>
        <div style="padding: 20px;">
            <van-button type="primary"  size="large"  @click.stop="save">注册</van-button>
        </div>
        <div style="padding: 10px">
            <p class="fl link" v-rblink.replace="{name:'login'}">账号密码登录</p>
            <p class="link fr" v-rblink.replace="{name:'loginBySms'}">短信快捷登录</p>
        </div>
    </div>
</template>


<style scoped="">
</style>
<script>
    import {
        Cell, CellGroup,NoticeBar,Field,Button
    } from 'vant';
    export default {
        name: 'regist',
        components: {
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [NoticeBar.name]: NoticeBar,
            [Button.name]: Button,
        },
        data: function () {
            return {
                clockSecond:0,
                formData:{
                    name:'',
                    phone:'',
                    password:'',
                    code:'',
                }
            }
        },
        mounted: function () {
            document.title = "用户注册";
        },
        methods: {
            getCode(){
                //获取验证码
                var that = this;
                this.$api.post("/api/index/phonecode", {
                    'phone' :that.formData.phone
                }, r => {
                    that.clockSecond = 60;
                    var t = setInterval(function () {
                        if(that.clockSecond>0){
                            that.clockSecond--;
                        }else{
                            clearInterval(t);
                        }
                    },1000)
                });
            },
            save(){
                var that = this;
                this.$api.get("/api/index/register", that.formData, r => {
                    //that.$toast.fail('成功');
                    localStorage.setItem('_pspt',r.data.token);
                    appEvent({
                        name: 'login',
                        query: {
                            token:r.data.token
                        }
                    });
                    setTimeout(function(){
                        rbLink({
                            'name':'xxx'
                        },'back');
                    },500);
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// regist.vue?18669324